<div class="fixed bottom-0 left-0 right-0 top-0 z-40 bg-black opacity-50"></div>
<div class="fixed bottom-0 left-0 right-0 top-0 z-50 overflow-y-scroll" role="dialog">
  <div class="flex min-h-full items-end justify-center sm:items-center">
    <div
      class="z-20 w-full space-y-xl rounded-t-3 bg-white shadow-lg sm:rounded-3"
      [ngClass]="{
        'p-md sm:w-[368px]': size === 'sm',
        'p-lg sm:w-[560px]': size === 'md',
        'px-xl py-lg md:w-[752px]': size === 'lg'
      }"
    >
      <div class="flex items-end justify-between rounded-t-3">
        <span class="heading-md">{{ title }}</span>

        @if (canBeClosed) {
          <button (click)="close()" class="btn btn-icon" role="button">
            <fa-icon [icon]="faTimes" size="lg"></fa-icon>
          </button>
        }
      </div>
      <div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
